export default __webpack_public_path__ + "media/src/assets/images/logo-thumbnail-031979a18fb5cb017d103d5d87f1ff46.png";